import  { useState } from 'react';
import {
    SpeedDial,
    SpeedDialAction,
    SpeedDialIcon,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    TextField,
    Box
} from '@mui/material';
import {
    Email,
    WhatsApp,
    Close,
    ContentCopy,
    Check
} from '@mui/icons-material';

const SocialNav = () => {
    const [open, setOpen] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogType, setDialogType] = useState<'email' | 'whatsapp' | ''>('');
    const [copied, setCopied] = useState(false);

    const email = 'info@ih-africa.com';
    const phone = '+255626195167';
    const defaultSubject = 'Portfolio Inquiry';
    const defaultBody = 'Hello Eng.Wilbroad,\n\nI came across your portfolio and wanted to reach out regarding...';

    const actions = [
        { icon: <Email />, name: 'Email', action: 'email' },
        { icon: <WhatsApp />, name: 'WhatsApp', action: 'whatsapp' },
    ];

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleActionClick = (type: 'email' | 'whatsapp') => {
        setDialogType(type);
        setDialogOpen(true);
        setOpen(false);
    };

    const handleCopyEmail = () => {
        navigator.clipboard.writeText(email);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const openWhatsApp = () => {
        window.open(`https://wa.me/${phone.replace(/\D/g, '')}`, '_blank');
        setDialogOpen(false);
    };

    const getEmailLink = () => {
        const encodedSubject = encodeURIComponent(defaultSubject);
        const encodedBody = encodeURIComponent(defaultBody);
        return `mailto:${email}?subject=${encodedSubject}&body=${encodedBody}`;
    };

    return (
        <>
            <SpeedDial
                ariaLabel="Contact options"
                sx={{ position: 'fixed', bottom: 32, right: 32 }}
                icon={<SpeedDialIcon />}
                onClose={handleClose}
                onOpen={handleOpen}
                open={open}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={() => handleActionClick(action.action as 'email' | 'whatsapp')}
                    />
                ))}
            </SpeedDial>

            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    {dialogType === 'email' ? 'Contact via Email' : 'Chat on WhatsApp'}
                </DialogTitle>
                <DialogContent>
                    {dialogType === 'email' ? (
                        <>
                            <DialogContentText>
                                You can email me at:
                            </DialogContentText>
                            <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                                <TextField
                                    value={email}
                                    fullWidth
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <Button
                                    onClick={handleCopyEmail}
                                    sx={{ ml: 1 }}
                                    startIcon={copied ? <Check /> : <ContentCopy />}
                                >
                                    {copied ? 'Copied!' : 'Copy'}
                                </Button>
                            </Box>

                            <Box sx={{ mt: 3 }}>
                                <TextField
                                    label="Subject"
                                    defaultValue={defaultSubject}
                                    fullWidth
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    label="Message"
                                    defaultValue={defaultBody}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={4}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Box>

                            <Button
                                fullWidth
                                variant="contained"
                                startIcon={<Email />}
                                href={getEmailLink()}
                                sx={{ mt: 2 }}
                            >
                                Open Email with Default Message
                            </Button>
                        </>
                    ) : (
                        <>
                            <DialogContentText>
                                You can contact me on WhatsApp:
                            </DialogContentText>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                                <Button
                                    variant="contained"
                                    color="success"
                                    startIcon={<WhatsApp />}
                                    onClick={openWhatsApp}
                                    sx={{ py: 1.5 }}
                                >
                                    Open WhatsApp Chat
                                </Button>
                            </Box>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)} startIcon={<Close />}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default SocialNav;